// Generated by GitHub Copilot
import { useTranslation } from 'react-i18next'
import type { AuthenticatorNotice } from './authenticator-app-state.ts'

/** The latest setup failure, in the panel's own words. */
export function AuthenticatorAppNotice({ notice }: { notice: AuthenticatorNotice | null }) {
  const { t } = useTranslation(['settings', 'auth'])
  if (!notice) return null
  return (
    <div className="text-danger mb-3" role="alert">
      {notice === 'invalidCode' ? t('auth:mfa.notice.invalidCode') : t(`settings:security.authenticator.notice.${notice}`)}
    </div>
  )
}
